import { P2GCdnImage, P2GGrid, P2GText } from '@parcel2go/core-ui';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

const TrackingResultError: React.FC = () => {
  const { t } = useTranslation(TranslationNamespaces.TRACKING);
  return (
    <P2GGrid container direction="column" justify="space-around" alignItems="center" spacing={5}>
      <P2GGrid item></P2GGrid>
      <P2GGrid item>
        <P2GCdnImage
          alt=""
          src="/trackingpages/stages/tracking-error.png"
          classNames="tracking-error-image"
        ></P2GCdnImage>
      </P2GGrid>
      <P2GGrid item xs={6}>
        <P2GText classNames="p2g-tracking-errortext" variant="h1">
          <Trans
            t={t}
            i18nKey="ERROR_MESSAGE_PROBLEM"
            defaults="We are having difficulty getting your tracking information"
          />
        </P2GText>
      </P2GGrid>
      <P2GGrid item xs={6}>
        <P2GText classNames="p2g-tracking-errortext2" variant="h1">
          <Trans t={t} i18nKey="ERROR_MESSAGE_NEXT_STEP" defaults="Please try again later" />
        </P2GText>
      </P2GGrid>
    </P2GGrid>
  );
};

export default TrackingResultError;
